import React from 'react';
import './OurProducts.css';

const OurProducts: React.FC = () => {
    return (
        <div className="our-products-content">
            <div className="gift-shop-intro">
                <p className="intro-text">
                    Beyond delicious food, we create unique handmade items perfect for gifts and home décor!
                </p>

                <p>
                    Contact us if you'd like to view our items in person in Cambourne before making a purchase.
                </p>
            </div>

            <a
                href="https://www.etsy.com/shop/TheMoiraisBoon"
                target="_blank"
                rel="noopener noreferrer"
                className="etsy-shop-link"
            >
                <h3 className="clickable-title">Visit our shop on Etsy 🛍️</h3>
            </a>
        </div>
    );
};

export default OurProducts;
